// extracted by mini-css-extract-plugin
export default {"DocTemplateTargetItem":"DocTemplates_DocTemplateTargetItem__hXClN","DocTemplateTargetItemSimple":"DocTemplates_DocTemplateTargetItemSimple__XepR6"};